"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var select_field_1 = require("../../../../../../../components/form/select-field");
var date_1 = require("@internationalized/date");
var condition_node_1 = __importDefault(require("../condition_node"));
var react_2 = require("react");
var challenge_1 = require("../../../../../../../reducers/slices/challenge/challenge");
var react_redux_1 = require("react-redux");
var challengeEditorContext_1 = require("../../../../../../../contexts/challengeEditorContext");
var TimeConditionNode = function (props) {
    var isReadOnly = (0, challengeEditorContext_1.useChallengeReadOnly)();
    var data = props.data;
    var dispatch = (0, react_redux_1.useDispatch)();
    var setConfigData = function (key, value) {
        var _a;
        console.log("key", key);
        console.log("value", value);
        var config = __assign(__assign({}, data.config), (_a = {}, _a[key] = value, _a));
        dispatch((0, challenge_1.setNode)(__assign(__assign({}, props), { data: __assign(__assign({}, data), { config: config }) })));
    };
    var configurationComponent = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-2", children: [(0, jsx_runtime_1.jsx)(select_field_1.SelectField, { isDisabled: isReadOnly, label: "Range Type", value: data.config.range_type, onChange: function (value) { return setConfigData("range_type", value); }, items: [
                        { label: "After", value: "after" },
                        { label: "Before", value: "before" },
                    ] }), (0, jsx_runtime_1.jsxs)(react_1.TimeField, { value: (0, date_1.parseTime)(data.config.time), onChange: function (time) { return setConfigData("time", time.toString()); }, children: [(0, jsx_runtime_1.jsx)(react_1.Label, { children: "Time" }), (0, jsx_runtime_1.jsx)(react_1.TimeField.Group, { children: (0, jsx_runtime_1.jsx)(react_1.TimeField.Input, { children: function (segment) { return (0, jsx_runtime_1.jsx)(react_1.TimeField.Segment, { segment: segment }); } }) })] })] }));
    };
    return (0, jsx_runtime_1.jsx)(condition_node_1.default, __assign({ data: data }, props, { configurationComponent: configurationComponent }));
};
exports.default = (0, react_2.memo)(TimeConditionNode);
